import { Injectable } from '@angular/core';
import { StorageService } from '../../shared/services/storage.service';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { OAuthService } from 'angular-oauth2-oidc';
@Injectable({
    providedIn: 'root',
  })
export class MedalliaService {

    constructor(
		private storageService: StorageService,
		private homeserveService: HomeserveService,
		private oauthService: OAuthService
		) {

		}

    initValues() {
		this.setValue("Exito_siniestro",0);
		this.setValue("CodigoMDM_value",this.oauthService.getIdentityClaims()['id_mdm']);

		var language = this.homeserveService.getSelectedLanguage() ? this.homeserveService.getSelectedLanguage() : this.homeserveService.defaultLanguage;
		document.cookie = "language="+ language.i18nKey + "; SameSite=Lax; Secure";
		this.setValue('language', language.i18nKey);

		//CONFIRMAR CON CLIENTE SI SE RESETEAN ESTOS VALORES (AL ESTAR EN SESSION STORAGE PUEDEN TENER VALORES DE EJECUCIONES PASADAS)
		this.setValue("Tipo_siniestro","");
		this.setValue("NumPoliza_Value", "");
		this.setValue("Causa_siniestro","");
		this.setValue("Segmento_1", "");
        this.setValue("Segmento_2", "");
        this.setValue("Segmento_3", "");
		this.setValue("Siniestro_declarado", 0);
		this.setValue("Tipo_finalizacion", "");
		
	}

	callMedallia() {
		if ((window as any).KAMPYLE_ONSITE_SDK) {
			if ((window as any).KAMPYLE_ONSITE_SDK.updatePageView) {
			  (window as any).KAMPYLE_ONSITE_SDK.updatePageView();
			}
		  }
	}

	setValue(key:string, value:any) {
		this.storageService.save(key,value);
	}
}